import React from 'react'
import { createNgReactBridgeDirective } from '../../react-bridge'
import {
  JenkinsDatePickerDropdown,
  JenkinsDatePickerDropdownProps
} from '../../../legacy-design-system/date-picker/jenkins-date-picker-dropdown'

interface ReadyProp {
  readonly ready: boolean
}

type BridgeProps = ReadyProp & JenkinsDatePickerDropdownProps

function AngularJenkinsDatePickerDropdown({ ready, ...props }: BridgeProps) {
  return ready ? <JenkinsDatePickerDropdown {...props} /> : null
}

const props: Array<keyof JenkinsDatePickerDropdownProps> = [
  'required',
  'selectedOption',
  'setStartDate',
  'setEndDate',
  'invalidTimeRange',
  'invalidRelativeEndDate',
  'selectedStart',
  'selectedEnd',
  'isCustomStartDate',
  'isCustomEndDate'
]

export const reactJenkinsDatePickerDropdown = createNgReactBridgeDirective(
  'reactJenkinsDatePickerDropdown',
  [],
  AngularJenkinsDatePickerDropdown,
  [
    [
      'ready',
      {
        watchDepth: 'reference'
      }
    ],
    ...props
  ]
)
